import { useState, useEffect, useCallback, createContext, useContext } from 'react';
import { getMe, login as apiLogin, logout as apiLogout } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshUser = useCallback(
    () => getMe().then(setUser).catch(() => setUser(null)),
    []
  );

  useEffect(() => {
    refreshUser().finally(() => setLoading(false));
  }, [refreshUser]);

  // Returns the raw API response so the caller (LoginPage) can branch on
  // requires2FA / requires2FASetup rather than assuming login always
  // completes in one step.
  const login = async (email, password) => {
    const data = await apiLogin(email, password);
    if (data.user) setUser(data.user);
    return data;
  };

  const logout = async () => {
    try {
      await apiLogout();
    } finally {
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
